import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead, prefillInquiry } from "@/components/Reveal";

const CAPS = [
  { no: "01", title: "5-Axis Machining", body: "Discuss complex geometry and multi-axis machining requirements." },
  { no: "02", title: "CNC Milling & Turning", body: "Precision machining for the features, surfaces, and fits defined by your design." },
  { no: "03", title: "Wire & Sinker EDM", body: "Additional machining options for demanding part requirements." },
  { no: "04", title: "Grinding", body: "Bring your dimensional and finishing requirements into the manufacturing conversation." },
  { no: "05", title: "Sub-Assembly & Full Assembly", body: "Build-to-order support that extends beyond the individual component." },
];

// E — Capabilities / service cards in the Peak design language.
export const Capabilities = () => (
  <section id="capabilities" data-testid="capabilities-section" className="on-light bg-[var(--cream)] py-24 sm:py-32">
    <div className="wrap">
      <SectionHead
        no="02"
        eyebrow="MANUFACTURING CAPABILITIES"
        title={<>Give the design <span className="font-serif-i">a way forward.</span></>}
        intro="Different features call for different processes. Explore PMP’s machining and assembly capabilities around what your project needs."
      />

      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {CAPS.map((c, i) => (
          <Reveal key={c.no} delay={i * 0.07} className={i === 4 ? "sm:col-span-2 lg:col-span-1" : ""}>
            <button
              type="button"
              data-testid={`capability-card-${i + 1}`}
              onClick={() => prefillInquiry({ capability: c.title })}
              className="card group flex h-full w-full flex-col p-7 text-left"
            >
              <span className="font-mono text-[11px] tracking-[0.2em] text-[var(--blue)]">{c.no}</span>
              <h3 className="mt-14 text-[1.35rem] font-semibold leading-snug tracking-[-0.02em] text-[var(--ink)] sm:mt-16">{c.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[var(--grey)] [text-wrap:pretty]">{c.body}</p>
              <span className="mt-6 flex items-center gap-1.5 font-mono text-[10.5px] tracking-[0.18em] text-[var(--ink-soft)] transition-colors group-hover:text-[var(--blue)]">
                DISCUSS THIS CAPABILITY
                <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </button>
          </Reveal>
        ))}
        <Reveal delay={0.35} className="sm:col-span-2 lg:col-span-3">
          <div className="flex flex-col items-start justify-between gap-6 rounded-[0.75rem] bg-[var(--ink)] p-8 sm:flex-row sm:items-center sm:p-10">
            <p className="font-serif-i text-2xl text-[var(--cream)] sm:text-3xl">Not sure which process fits? That’s the right first question.</p>
            <button type="button" data-testid="capabilities-talk-button" onClick={() => prefillInquiry({})} className="btn btn-light shrink-0">
              Talk Through Your Part
            </button>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
